<template>
  <div class="min-h-screen bg-gray-200">
    <router-view></router-view>
  </div>
</template>
